/**
 * AdminAgentStreamRpcClient - AtomRpc integration for the admin subset of
 * the agent-stream endpoints (`AgentStreamRpcs`). The browser only ever
 * calls the admin-gated `admin.agent.dispatchCommand` RPC from here — the
 * "Backup now" action on the agent detail page dispatches a `backup.now`
 * command to the install's management agent. The agent-secret endpoints in
 * the same group (streaming, heartbeat, ingestion) are never invoked from
 * the browser; their `AgentSecretMiddleware` is not `requiredForClient`, so
 * no client middleware layer is needed.
 *
 * Requires admin authentication via the Clerk session token (attached by
 * the shared protocol layer).
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AgentStreamRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminAgentStreamRpcClient extends AtomRpc.Tag<AdminAgentStreamRpcClient>()(
  "AdminAgentStreamRpcClient",
  {
    group: AgentStreamRpcs,
    protocol: makeRpcClientLayer(AgentStreamRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
